module.exports = __webpack_public_path__ + "static/media/500.0d5fb95d.svg";